import { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';
import { Item } from 'src/types/entities/Item';
import { Widget } from 'src/types/entities/Widget';
import { KeyPhrase } from 'src/types/entities/KeyPhrase';
import { KeyPhraseState } from 'src/types/values/KeyPhraseState';
import { getSelectedWidget } from 'src/react/selectedWidget/selectors/getSelectedWidget';
import { getKeyPhraseEndpoint } from 'src/react/api/selectors/getEndpoint';
import { IKeyPhraseEndpoint } from 'src/react/api/endpoints/KeyPhraseEndpoint';
import { keyPhraseGet } from 'src/react/demoPage/services/keyPhraseGet';

export function* itemKeyPhraseAttach(item: Item, keyPhraseText: string): SagaIterator {
    const widget: Widget = yield select(getSelectedWidget);
    const keyPhraseEndpoint: IKeyPhraseEndpoint = yield select(getKeyPhraseEndpoint);

    const keyPhrase: KeyPhrase | undefined = yield call(keyPhraseGet, keyPhraseText);
    if (!keyPhrase) {
        return yield call({
            fn: keyPhraseEndpoint.create,
            context: keyPhraseEndpoint,
        }, {
            state: KeyPhraseState.Active,
            text: keyPhraseText,
            itemIds: [item.id],
            synonyms: [],
        }, {
            widgetId: widget.id,
        });
    }
    if (keyPhrase.itemIds.includes(item.id)) {
        return keyPhrase;
    }

    return yield call({
        fn: keyPhraseEndpoint.update,
        context: keyPhraseEndpoint,
    }, keyPhrase.id, {
        state: KeyPhraseState.Active,
        text: keyPhraseText,
        itemIds: [...keyPhrase.itemIds, item.id],
        synonyms: keyPhrase.synonyms,
    }, {
        widgetId: widget.id,
    });
}
